export function clearSelection(gridView) {
  const selection = {
    ...gridView.get('selection'),
    selected: [],
  };

  gridView.trigger('willSelect', selection.selected);
  gridView.set({ selection }, () => {
    gridView.trigger('didSelect', selection.selected);
  });
}

export function toggleRadioButton(e, gridView) {
  const radioButton = e.target;
  const { selected } = gridView.get('selection');
  const key = gridView.keyOfElement(radioButton);

  if (selected.includes(key)) {
    radioButton.checked = false;
    clearSelection(gridView);
  }
}
